import { Form, Input, Select, Radio, Button, Card, Space, Row, Col } from 'antd'
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons'
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import TimeDurationFormItem from '../../../components/TimeDurationFormItem'
import AuthComponent from '../../../components/AuthComponent'
import SupplierSelect from '../../../components/BaseInfoSelects/SupplierSelect'
import useBillTypeContext from '../hooks/useStockBillTypeContext'
import { inventoryTypeEnum, inventoryTypeMap } from '../config'
import { useEffect, useState } from 'react'

const wayTaps = {
  AUTO_: '自动',
  COUNT_: '数量'
}
const selectStyle = { width: '140px' }
const durationKeys = ['beginDate', 'endDate']
const defaultVal = { wayType: '', status: '' }
export default function SearchBasicForm({
  getList = Promise.resolve,
  children = '',
  stockType,
}) {
  const { type, baseQueryModule, no } = useBillTypeContext()
  const typeTxt = inventoryTypeMap[type]
  const [getDefaultData, setGetDefaultData] = useState(false)
  const defaultStoreCodeGetData = res => {
    form.setFieldsValue({ storeCode: res.storeCode })
    setGetDefaultData(true)
    // queryBaseList()
  }

  const [form] = Form.useForm()
  form.setFieldsValue({no})
  const queryBaseList = () => {
    if (form.getFieldValue('storeCode')) {
      let formData = form.getFieldsValue()
      delete formData.duration
      getList({ formData: formData })
    }
  }
  useEffect(() => {
    getDefaultData && queryBaseList()
  }, [stockType, getDefaultData])
  return (
    <Card>
      <Form
        wrapperCol={{ style: { marginBottom: 20 } }}
        style={{ marginBottom: -20 }}
        layout='inline'
        labelCol={{ style: { width: 90, textAlign: 'right' } }}
        form={form}
        initialValues={defaultVal}>
        {/* <Row>
          <Col span={7}> */}
        <Form.Item name='storeCode' label='所属门店' required>
          <ShopSelect
            keyVal='storeCode'
            style={selectStyle}
            OnOptionsLoad={defaultStoreCodeGetData}
          />
        </Form.Item>
        {/* </Col>
          <Col span={7} offset={1} style={{ textAlign: 'left' }}> */}
        <Form.Item name='wayType' label={typeTxt + '方式'}>
          <Select style={{ width: 120, textAlign: 'left' }}>
            <Select.Option key='1' value={''}>
              全部
            </Select.Option>
            {Object.keys(wayTaps).map(item => (
              <Select.Option key={item + type} value={item + type}>
                {wayTaps[item]}
                {typeTxt}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {/* </Col>
          <Col span={7} offset={1}> */}
        <Form.Item name='supplierId' label='所属供应商'>
          <SupplierSelect style={selectStyle} />
        </Form.Item>
        {/* </Col> */}
        {/* </Row>
        <Row>
          <Col span={7}> */}
        <Form.Item name='no' label={typeTxt + '单据'}>
          <Input placeholder='请输入' style={selectStyle} />
        </Form.Item>
        {/* </Col>
          <Col span={12} offset={1} style={{ textAlign: 'left' }}> */}
        <TimeDurationFormItem
          keys={durationKeys}
          form={form}
          label='单据时间'
        />
        {/* </Col>
        </Row>
        <Row>
          <Col span={7}> */}
        <Form.Item name='status' label='单据状态'>
          <Radio.Group>
            <Radio value={''} key='6'>
              全部
            </Radio>
            <Radio value='FINISHED' key='FINISHED'>
              已完成
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <Space>
            <AuthComponent authKey={baseQueryModule.baseQueryPath + 'list'}>
              <Button
                type='primary'
                ghost
                onClick={queryBaseList}
                icon={<SearchOutlined />}>
                查询
              </Button>
            </AuthComponent>
            <Button
              type='primary'
              ghost
              icon={<ReloadOutlined />}
              onClick={() => form.resetFields()}>
              重置
            </Button>
            {children}
          </Space>
        </Form.Item>
        {/* </Col>
        </Row> */}
      </Form>
    </Card>
  )
}
